import { SIDEBAR_STATE, SIDEBAR_LOCALSTORAGE_KEY } from '../constants';

import {
  CREATE_ALERT_SUCCESS,
  REMOVE_ALERT_ERROR,
  REMOVE_ALERT_REQUEST,
  REMOVE_ALERT_SUCCESS,
  RESTORE_ALERT_SUCCESS,
  SORT_ALERTS,
  OPEN_ALERTS,
  CLOSE_ALERTS,
} from '../actions/alert';

import {
  ADD_LIST_ITEM_SUCCESS,
  REMOVE_LIST_ITEM_ERROR,
  REMOVE_LIST_ITEM_REQUEST,
  REMOVE_LIST_ITEM_SUCCESS,
  RESTORE_LIST_ITEM_SUCCESS,
  REMOVE_LIST_ERROR,
  REMOVE_LIST_REQUEST,
  REMOVE_LIST_SUCCESS,
  RESTORE_LIST_SUCCESS,
  CREATE_LIST_SUCCESS,
  RENAME_LIST_SUCCESS,
  SORT_LIST,
  SELECT_LIST,
  OPEN_LISTS,
  CLOSE_LISTS,
  ORDER_LISTS_REQUEST,
  ORDER_LIST_ITEMS_REQUEST,
} from '../actions/lists';

import { TOGGLE_FILTER } from '../actions/filter';

const setSidebarStorageState = value => {
  const storedValue = JSON.parse(
    localStorage.getItem(SIDEBAR_LOCALSTORAGE_KEY)
  );
  localStorage.setItem(
    SIDEBAR_LOCALSTORAGE_KEY,
    JSON.stringify({ ...storedValue, ...value })
  );
};

const setListSortStorageState = listSort => {
  setSidebarStorageState({ listSort });
};

const setListTabStorageState = activeTab => {
  setSidebarStorageState({ tab: activeTab });
};

export default (state, action) => {
  if (!state) {
    return {
      open: false,
      tab: SIDEBAR_STATE.NONE,
      previousTab: null,
      error: null,
      pending: false,
      createdAlerts: {},
      deletedAlerts: {},
      deletedListItems: {},
      deletedLists: {},
      createdLists: [],
      tracking: {},
      alerts: {
        sort: 'price_change',
        direction: 'desc',
      },
      selectedList: null,
      lists: {},
      listRefresh: 0,
    };
  }

  switch (action.type) {
    case '__DANGEROUS_CONFIG_RECEIVE': {
      return {
        ...state,
        tracking: {
          settings: action.market.trackingToggles.reduce(
            (settings, setting) => ({
              ...settings,
              [setting.name]: setting.default,
            }),
            []
          ),
        },
      };
    }

    case 'SESSION_RECEIVE': {
      return {
        ...state,
        tracking: {
          ...state.tracking,
          settings: {
            ...state.tracking.settings,
            ...Object.keys(action.privacyCookie || {}).reduce(
              (settings, curr) =>
                Object.assign(settings, {
                  [curr]: Boolean(action.privacyCookie[curr]),
                }),
              {}
            ),
          },
        },
        personalization: {
          clientId: action.clientId,
        },
      };
    }

    case 'ROUTE_LOADED': {
      // Close filter when navigating away from a leaf category page
      if (
        state.tab === SIDEBAR_STATE.FILTER &&
        (action.route.name !== 'category' ||
          !action.data.category.immediateProducts)
      ) {
        setListTabStorageState(SIDEBAR_STATE.NONE);
        return {
          ...state,
          tab: SIDEBAR_STATE.NONE,
        };
      }

      break;
    }

    case CLOSE_ALERTS: {
      setListTabStorageState(SIDEBAR_STATE.NONE);
      return {
        ...state,
        tab: SIDEBAR_STATE.NONE,
        open: false,
      };
    }

    case OPEN_ALERTS: {
      setListTabStorageState(SIDEBAR_STATE.ALERTS);

      return {
        ...state,
        tab: SIDEBAR_STATE.ALERTS,
        previousTab: SIDEBAR_STATE.ALERTS,
        open: true,
      };
    }

    case CLOSE_LISTS: {
      setListTabStorageState(SIDEBAR_STATE.NONE);
      return {
        ...state,
        tab: SIDEBAR_STATE.NONE,
        open: false,
      };
    }

    case OPEN_LISTS: {
      setListTabStorageState(SIDEBAR_STATE.LISTS);
      return {
        ...state,
        tab: SIDEBAR_STATE.LISTS,
        previousTab: SIDEBAR_STATE.LISTS,
        open: true,
      };
    }

    case TOGGLE_FILTER: {
      if (!state.open) {
        setListTabStorageState(SIDEBAR_STATE.FILTER);
        return {
          ...state,
          tab: SIDEBAR_STATE.FILTER,
          previousTab: SIDEBAR_STATE.FILTER,
          open: true,
        };
      }
      if (state.open && state.tab === SIDEBAR_STATE.FILTER) {
        setListTabStorageState(SIDEBAR_STATE.NONE);
        return {
          ...state,
          tab: SIDEBAR_STATE.NONE,
          open: false,
        };
      }
      if (state.open && state.tab !== SIDEBAR_STATE.FILTER) {
        setListTabStorageState(SIDEBAR_STATE.FILTER);
        return {
          ...state,
          tab: SIDEBAR_STATE.FILTER,
          previousTab: SIDEBAR_STATE.FILTER,
          open: true,
        };
      }
      break;
    }

    case CREATE_ALERT_SUCCESS: {
      return {
        ...state,
        createdAlerts: {
          ...state.createdAlerts,
          [action.productId]: action.id,
        },
      };
    }

    case REMOVE_ALERT_REQUEST: {
      return {
        ...state,
        pending: true,
      };
    }

    case RESTORE_ALERT_SUCCESS: {
      const createdAlerts = state.createdAlerts;
      const productId = state.deletedAlerts[action.id];
      if (productId && productId !== true) {
        // We only need to store product alerts in this map
        createdAlerts[productId] = action.id;
      }
      return {
        ...state,
        createdAlerts,
        deletedAlerts: {
          ...state.deletedAlerts,
          [action.id]: undefined,
        },
      };
    }

    case REMOVE_ALERT_SUCCESS: {
      const createdAlerts = state.createdAlerts;
      if (action.productId) {
        delete createdAlerts[action.productId];
      }
      return {
        ...state,
        createdAlerts,
        deletedAlerts: {
          ...state.deletedAlerts,
          [action.id]: action.productId || true,
        },
        pending: false,
      };
    }

    case REMOVE_ALERT_ERROR: {
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    }

    case SORT_LIST: {
      const [sort, direction] = action.sort.value.split(':');
      setListSortStorageState(action.sort.value);

      return {
        ...state,
        lists: {
          ...state.lists,
          sort,
          direction,
        },
      };
    }

    case SORT_ALERTS: {
      const [sort, direction] = action.sort.value.split(':');

      return {
        ...state,
        alerts: {
          ...state.alerts,
          sort,
          direction,
        },
      };
    }

    case SELECT_LIST: {
      return {
        ...state,
        selectedList: action.id,
      };
    }

    case REMOVE_LIST_ITEM_REQUEST: {
      return {
        ...state,
        pending: true,
        deletedListItems: {
          ...state.deletedListItems,
          [action.id]: 'pending',
        },
      };
    }

    case RESTORE_LIST_ITEM_SUCCESS: {
      return {
        ...state,
        deletedListItems: {
          ...state.deletedListItems,
          [action.id]: undefined,
        },
      };
    }

    case REMOVE_LIST_ITEM_SUCCESS: {
      return {
        ...state,
        listRefresh: state.listRefresh + 1,
        deletedListItems: {
          ...state.deletedListItems,
          [action.id]: action.productId || action.listId,
        },
        pending: false,
      };
    }

    case REMOVE_LIST_ITEM_ERROR: {
      return {
        ...state,
        pending: false,
        deletedListItems: {
          ...state.deletedListItems,
          [action.id]: undefined,
        },
      };
    }

    case REMOVE_LIST_REQUEST: {
      return {
        ...state,
        pending: true,
        deletedLists: {
          ...state.deletedLists,
          [action.id]: 'pending',
        },
      };
    }

    case RESTORE_LIST_SUCCESS: {
      return {
        ...state,
        listRefresh: state.listRefresh + 1,
        deletedLists: {
          ...state.deletedLists,
          [action.id]: undefined,
        },
      };
    }

    case REMOVE_LIST_SUCCESS: {
      return {
        ...state,
        listRefresh: state.listRefresh + 1,
        deletedLists: {
          ...state.deletedLists,
          [action.id]: true,
        },
        pending: false,
      };
    }

    case REMOVE_LIST_ERROR: {
      return {
        ...state,
        pending: false,
        listRefresh: state.listRefresh + 1,
        deletedLists: {
          ...state.deletedLists,
          [action.id]: undefined,
        },
      };
    }

    case CREATE_LIST_SUCCESS: {
      return {
        ...state,
        listRefresh: state.listRefresh + 1,
        createdLists: [action.list].concat(state.createdLists),
      };
    }

    case RENAME_LIST_SUCCESS: {
      return {
        ...state,
        listRefresh: state.listRefresh + 1, // Update UI when renaming list
      };
    }

    case ADD_LIST_ITEM_SUCCESS: {
      return {
        ...state,
        listRefresh: state.listRefresh + 1,
      };
    }

    case ORDER_LISTS_REQUEST: {
      return {
        ...state,
      };
    }

    case ORDER_LIST_ITEMS_REQUEST: {
      return {
        ...state,
      };
    }

    default:
      break;
  }

  return state;
};
